module.exports = __webpack_public_path__ + "img/email-en.7ebe4e12.jpg";